"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseInfo = exports.TableMember = exports.TableInfo = exports.IndexDef = exports.ColumnDef = exports.ResultSet = exports.RowData = exports.Argument = exports.argument_VarTypeToJSON = exports.argument_VarTypeFromJSON = exports.Argument_VarType = exports.columnValueTypeToJSON = exports.columnValueTypeFromJSON = exports.ColumnValueType = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "blockved.glitterchain.index";
var ColumnValueType;
(function (ColumnValueType) {
    ColumnValueType[ColumnValueType["InvalidColumn"] = 0] = "InvalidColumn";
    ColumnValueType[ColumnValueType["IntColumn"] = 1] = "IntColumn";
    ColumnValueType[ColumnValueType["UintColumn"] = 2] = "UintColumn";
    ColumnValueType[ColumnValueType["FloatColumn"] = 3] = "FloatColumn";
    ColumnValueType[ColumnValueType["BoolColumn"] = 4] = "BoolColumn";
    ColumnValueType[ColumnValueType["StringColumn"] = 5] = "StringColumn";
    ColumnValueType[ColumnValueType["BytesColumn"] = 6] = "BytesColumn";
    ColumnValueType[ColumnValueType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ColumnValueType = exports.ColumnValueType || (exports.ColumnValueType = {}));
function columnValueTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "InvalidColumn":
            return ColumnValueType.InvalidColumn;
        case 1:
        case "IntColumn":
            return ColumnValueType.IntColumn;
        case 2:
        case "UintColumn":
            return ColumnValueType.UintColumn;
        case 3:
        case "FloatColumn":
            return ColumnValueType.FloatColumn;
        case 4:
        case "BoolColumn":
            return ColumnValueType.BoolColumn;
        case 5:
        case "StringColumn":
            return ColumnValueType.StringColumn;
        case 6:
        case "BytesColumn":
            return ColumnValueType.BytesColumn;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ColumnValueType.UNRECOGNIZED;
    }
}
exports.columnValueTypeFromJSON = columnValueTypeFromJSON;
function columnValueTypeToJSON(object) {
    switch (object) {
        case ColumnValueType.InvalidColumn:
            return "InvalidColumn";
        case ColumnValueType.IntColumn:
            return "IntColumn";
        case ColumnValueType.UintColumn:
            return "UintColumn";
        case ColumnValueType.FloatColumn:
            return "FloatColumn";
        case ColumnValueType.BoolColumn:
            return "BoolColumn";
        case ColumnValueType.StringColumn:
            return "StringColumn";
        case ColumnValueType.BytesColumn:
            return "BytesColumn";
        default:
            return "UNKNOWN";
    }
}
exports.columnValueTypeToJSON = columnValueTypeToJSON;
var Argument_VarType;
(function (Argument_VarType) {
    Argument_VarType[Argument_VarType["INT"] = 0] = "INT";
    Argument_VarType[Argument_VarType["UINT"] = 1] = "UINT";
    Argument_VarType[Argument_VarType["FLOAT"] = 2] = "FLOAT";
    Argument_VarType[Argument_VarType["BOOL"] = 3] = "BOOL";
    Argument_VarType[Argument_VarType["STRING"] = 4] = "STRING";
    Argument_VarType[Argument_VarType["BYTES"] = 5] = "BYTES";
    Argument_VarType[Argument_VarType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Argument_VarType = exports.Argument_VarType || (exports.Argument_VarType = {}));
function argument_VarTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "INT":
            return Argument_VarType.INT;
        case 1:
        case "UINT":
            return Argument_VarType.UINT;
        case 2:
        case "FLOAT":
            return Argument_VarType.FLOAT;
        case 3:
        case "BOOL":
            return Argument_VarType.BOOL;
        case 4:
        case "STRING":
            return Argument_VarType.STRING;
        case 5:
        case "BYTES":
            return Argument_VarType.BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Argument_VarType.UNRECOGNIZED;
    }
}
exports.argument_VarTypeFromJSON = argument_VarTypeFromJSON;
function argument_VarTypeToJSON(object) {
    switch (object) {
        case Argument_VarType.INT:
            return "INT";
        case Argument_VarType.UINT:
            return "UINT";
        case Argument_VarType.FLOAT:
            return "FLOAT";
        case Argument_VarType.BOOL:
            return "BOOL";
        case Argument_VarType.STRING:
            return "STRING";
        case Argument_VarType.BYTES:
            return "BYTES";
        default:
            return "UNKNOWN";
    }
}
exports.argument_VarTypeToJSON = argument_VarTypeToJSON;
const baseArgument = { type: 0, value: "" };
exports.Argument = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.value !== "") {
            writer.uint32(26).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseArgument);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 3:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseArgument);
        if (object.type !== undefined && object.type !== null) {
            message.type = argument_VarTypeFromJSON(object.type);
        }
        else {
            message.type = 0;
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = String(object.value);
        }
        else {
            message.value = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = argument_VarTypeToJSON(message.type));
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseArgument);
        if (object.type !== undefined && object.type !== null) {
            message.type = object.type;
        }
        else {
            message.type = 0;
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseRowData = { columns: "" };
exports.RowData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.columns) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRowData);
        message.columns = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.columns.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRowData);
        message.columns = [];
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(String(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.columns) {
            obj.columns = message.columns.map((e) => e);
        }
        else {
            obj.columns = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseRowData);
        message.columns = [];
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(e);
            }
        }
        return message;
    },
};
const baseResultSet = { id: "" };
exports.ResultSet = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        for (const v of message.columnDefs) {
            exports.ColumnDef.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.rows) {
            exports.RowData.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseResultSet);
        message.columnDefs = [];
        message.rows = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.columnDefs.push(exports.ColumnDef.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.rows.push(exports.RowData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseResultSet);
        message.columnDefs = [];
        message.rows = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = String(object.id);
        }
        else {
            message.id = "";
        }
        if (object.columnDefs !== undefined && object.columnDefs !== null) {
            for (const e of object.columnDefs) {
                message.columnDefs.push(exports.ColumnDef.fromJSON(e));
            }
        }
        if (object.rows !== undefined && object.rows !== null) {
            for (const e of object.rows) {
                message.rows.push(exports.RowData.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        if (message.columnDefs) {
            obj.columnDefs = message.columnDefs.map((e) => (e ? exports.ColumnDef.toJSON(e) : undefined));
        }
        else {
            obj.columnDefs = [];
        }
        if (message.rows) {
            obj.rows = message.rows.map((e) => (e ? exports.RowData.toJSON(e) : undefined));
        }
        else {
            obj.rows = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseResultSet);
        message.columnDefs = [];
        message.rows = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = "";
        }
        if (object.columnDefs !== undefined && object.columnDefs !== null) {
            for (const e of object.columnDefs) {
                message.columnDefs.push(exports.ColumnDef.fromPartial(e));
            }
        }
        if (object.rows !== undefined && object.rows !== null) {
            for (const e of object.rows) {
                message.rows.push(exports.RowData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseColumnDef = { columnName: "", columnType: "", comment: "", columnValueType: 0 };
exports.ColumnDef = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.columnName !== "") {
            writer.uint32(10).string(message.columnName);
        }
        if (message.columnType !== "") {
            writer.uint32(18).string(message.columnType);
        }
        if (message.comment !== "") {
            writer.uint32(26).string(message.comment);
        }
        if (message.columnValueType !== 0) {
            writer.uint32(32).int32(message.columnValueType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseColumnDef);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.columnName = reader.string();
                    break;
                case 2:
                    message.columnType = reader.string();
                    break;
                case 3:
                    message.comment = reader.string();
                    break;
                case 4:
                    message.columnValueType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseColumnDef);
        if (object.columnName !== undefined && object.columnName !== null) {
            message.columnName = String(object.columnName);
        }
        else {
            message.columnName = "";
        }
        if (object.columnType !== undefined && object.columnType !== null) {
            message.columnType = String(object.columnType);
        }
        else {
            message.columnType = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        if (object.columnValueType !== undefined && object.columnValueType !== null) {
            message.columnValueType = columnValueTypeFromJSON(object.columnValueType);
        }
        else {
            message.columnValueType = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.columnName !== undefined && (obj.columnName = message.columnName);
        message.columnType !== undefined && (obj.columnType = message.columnType);
        message.comment !== undefined && (obj.comment = message.comment);
        message.columnValueType !== undefined &&
            (obj.columnValueType = columnValueTypeToJSON(message.columnValueType));
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseColumnDef);
        if (object.columnName !== undefined && object.columnName !== null) {
            message.columnName = object.columnName;
        }
        else {
            message.columnName = "";
        }
        if (object.columnType !== undefined && object.columnType !== null) {
            message.columnType = object.columnType;
        }
        else {
            message.columnType = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        if (object.columnValueType !== undefined && object.columnValueType !== null) {
            message.columnValueType = object.columnValueType;
        }
        else {
            message.columnValueType = 0;
        }
        return message;
    },
};
const baseIndexDef = { indexName: "", indexType: "", isPrimaryKey: false, parser: "", comment: "" };
exports.IndexDef = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.indexName !== "") {
            writer.uint32(10).string(message.indexName);
        }
        if (message.indexType !== "") {
            writer.uint32(18).string(message.indexType);
        }
        for (const v of message.columns) {
            exports.ColumnDef.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.isPrimaryKey === true) {
            writer.uint32(40).bool(message.isPrimaryKey);
        }
        if (message.parser !== "") {
            writer.uint32(50).string(message.parser);
        }
        if (message.comment !== "") {
            writer.uint32(58).string(message.comment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseIndexDef);
        message.columns = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.indexName = reader.string();
                    break;
                case 2:
                    message.indexType = reader.string();
                    break;
                case 4:
                    message.columns.push(exports.ColumnDef.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.isPrimaryKey = reader.bool();
                    break;
                case 6:
                    message.parser = reader.string();
                    break;
                case 7:
                    message.comment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseIndexDef);
        message.columns = [];
        if (object.indexName !== undefined && object.indexName !== null) {
            message.indexName = String(object.indexName);
        }
        else {
            message.indexName = "";
        }
        if (object.indexType !== undefined && object.indexType !== null) {
            message.indexType = String(object.indexType);
        }
        else {
            message.indexType = "";
        }
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(exports.ColumnDef.fromJSON(e));
            }
        }
        if (object.isPrimaryKey !== undefined && object.isPrimaryKey !== null) {
            message.isPrimaryKey = Boolean(object.isPrimaryKey);
        }
        else {
            message.isPrimaryKey = false;
        }
        if (object.parser !== undefined && object.parser !== null) {
            message.parser = String(object.parser);
        }
        else {
            message.parser = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.indexName !== undefined && (obj.indexName = message.indexName);
        message.indexType !== undefined && (obj.indexType = message.indexType);
        if (message.columns) {
            obj.columns = message.columns.map((e) => (e ? exports.ColumnDef.toJSON(e) : undefined));
        }
        else {
            obj.columns = [];
        }
        message.isPrimaryKey !== undefined && (obj.isPrimaryKey = message.isPrimaryKey);
        message.parser !== undefined && (obj.parser = message.parser);
        message.comment !== undefined && (obj.comment = message.comment);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseIndexDef);
        message.columns = [];
        if (object.indexName !== undefined && object.indexName !== null) {
            message.indexName = object.indexName;
        }
        else {
            message.indexName = "";
        }
        if (object.indexType !== undefined && object.indexType !== null) {
            message.indexType = object.indexType;
        }
        else {
            message.indexType = "";
        }
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(exports.ColumnDef.fromPartial(e));
            }
        }
        if (object.isPrimaryKey !== undefined && object.isPrimaryKey !== null) {
            message.isPrimaryKey = object.isPrimaryKey;
        }
        else {
            message.isPrimaryKey = false;
        }
        if (object.parser !== undefined && object.parser !== null) {
            message.parser = object.parser;
        }
        else {
            message.parser = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        return message;
    },
};
const baseTableInfo = {
    tableName: "",
    dbName: "",
    engine: "",
    createStatement: "",
    comment: "",
    creator: "",
};
exports.TableInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tableName !== "") {
            writer.uint32(10).string(message.tableName);
        }
        if (message.dbName !== "") {
            writer.uint32(18).string(message.dbName);
        }
        if (message.engine !== "") {
            writer.uint32(26).string(message.engine);
        }
        for (const v of message.columns) {
            exports.ColumnDef.encode(v, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.indexes) {
            exports.IndexDef.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.createStatement !== "") {
            writer.uint32(50).string(message.createStatement);
        }
        if (message.comment !== "") {
            writer.uint32(58).string(message.comment);
        }
        if (message.creator !== "") {
            writer.uint32(66).string(message.creator);
        }
        for (const v of message.members) {
            exports.TableMember.encode(v, writer.uint32(74).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTableInfo);
        message.columns = [];
        message.indexes = [];
        message.members = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tableName = reader.string();
                    break;
                case 2:
                    message.dbName = reader.string();
                    break;
                case 3:
                    message.engine = reader.string();
                    break;
                case 4:
                    message.columns.push(exports.ColumnDef.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.indexes.push(exports.IndexDef.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.createStatement = reader.string();
                    break;
                case 7:
                    message.comment = reader.string();
                    break;
                case 8:
                    message.creator = reader.string();
                    break;
                case 9:
                    message.members.push(exports.TableMember.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTableInfo);
        message.columns = [];
        message.indexes = [];
        message.members = [];
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = String(object.tableName);
        }
        else {
            message.tableName = "";
        }
        if (object.dbName !== undefined && object.dbName !== null) {
            message.dbName = String(object.dbName);
        }
        else {
            message.dbName = "";
        }
        if (object.engine !== undefined && object.engine !== null) {
            message.engine = String(object.engine);
        }
        else {
            message.engine = "";
        }
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(exports.ColumnDef.fromJSON(e));
            }
        }
        if (object.indexes !== undefined && object.indexes !== null) {
            for (const e of object.indexes) {
                message.indexes.push(exports.IndexDef.fromJSON(e));
            }
        }
        if (object.createStatement !== undefined && object.createStatement !== null) {
            message.createStatement = String(object.createStatement);
        }
        else {
            message.createStatement = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = String(object.comment);
        }
        else {
            message.comment = "";
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.members !== undefined && object.members !== null) {
            for (const e of object.members) {
                message.members.push(exports.TableMember.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.tableName !== undefined && (obj.tableName = message.tableName);
        message.dbName !== undefined && (obj.dbName = message.dbName);
        message.engine !== undefined && (obj.engine = message.engine);
        if (message.columns) {
            obj.columns = message.columns.map((e) => (e ? exports.ColumnDef.toJSON(e) : undefined));
        }
        else {
            obj.columns = [];
        }
        if (message.indexes) {
            obj.indexes = message.indexes.map((e) => (e ? exports.IndexDef.toJSON(e) : undefined));
        }
        else {
            obj.indexes = [];
        }
        message.createStatement !== undefined && (obj.createStatement = message.createStatement);
        message.comment !== undefined && (obj.comment = message.comment);
        message.creator !== undefined && (obj.creator = message.creator);
        if (message.members) {
            obj.members = message.members.map((e) => (e ? exports.TableMember.toJSON(e) : undefined));
        }
        else {
            obj.members = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTableInfo);
        message.columns = [];
        message.indexes = [];
        message.members = [];
        if (object.tableName !== undefined && object.tableName !== null) {
            message.tableName = object.tableName;
        }
        else {
            message.tableName = "";
        }
        if (object.dbName !== undefined && object.dbName !== null) {
            message.dbName = object.dbName;
        }
        else {
            message.dbName = "";
        }
        if (object.engine !== undefined && object.engine !== null) {
            message.engine = object.engine;
        }
        else {
            message.engine = "";
        }
        if (object.columns !== undefined && object.columns !== null) {
            for (const e of object.columns) {
                message.columns.push(exports.ColumnDef.fromPartial(e));
            }
        }
        if (object.indexes !== undefined && object.indexes !== null) {
            for (const e of object.indexes) {
                message.indexes.push(exports.IndexDef.fromPartial(e));
            }
        }
        if (object.createStatement !== undefined && object.createStatement !== null) {
            message.createStatement = object.createStatement;
        }
        else {
            message.createStatement = "";
        }
        if (object.comment !== undefined && object.comment !== null) {
            message.comment = object.comment;
        }
        else {
            message.comment = "";
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.members !== undefined && object.members !== null) {
            for (const e of object.members) {
                message.members.push(exports.TableMember.fromPartial(e));
            }
        }
        return message;
    },
};
const baseTableMember = { uid: "", role: "" };
exports.TableMember = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.uid !== "") {
            writer.uint32(10).string(message.uid);
        }
        if (message.role !== "") {
            writer.uint32(18).string(message.role);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTableMember);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.role = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTableMember);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = String(object.uid);
        }
        else {
            message.uid = "";
        }
        if (object.role !== undefined && object.role !== null) {
            message.role = String(object.role);
        }
        else {
            message.role = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.uid !== undefined && (obj.uid = message.uid);
        message.role !== undefined && (obj.role = message.role);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTableMember);
        if (object.uid !== undefined && object.uid !== null) {
            message.uid = object.uid;
        }
        else {
            message.uid = "";
        }
        if (object.role !== undefined && object.role !== null) {
            message.role = object.role;
        }
        else {
            message.role = "";
        }
        return message;
    },
};
const baseDatabaseInfo = { dbName: "", creator: "" };
exports.DatabaseInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.dbName !== "") {
            writer.uint32(10).string(message.dbName);
        }
        if (message.creator !== "") {
            writer.uint32(18).string(message.creator);
        }
        for (const v of message.members) {
            exports.TableMember.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDatabaseInfo);
        message.members = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.dbName = reader.string();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.members.push(exports.TableMember.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDatabaseInfo);
        message.members = [];
        if (object.dbName !== undefined && object.dbName !== null) {
            message.dbName = String(object.dbName);
        }
        else {
            message.dbName = "";
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.members !== undefined && object.members !== null) {
            for (const e of object.members) {
                message.members.push(exports.TableMember.fromJSON(e));
            }
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.dbName !== undefined && (obj.dbName = message.dbName);
        message.creator !== undefined && (obj.creator = message.creator);
        if (message.members) {
            obj.members = message.members.map((e) => (e ? exports.TableMember.toJSON(e) : undefined));
        }
        else {
            obj.members = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDatabaseInfo);
        message.members = [];
        if (object.dbName !== undefined && object.dbName !== null) {
            message.dbName = object.dbName;
        }
        else {
            message.dbName = "";
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.members !== undefined && object.members !== null) {
            for (const e of object.members) {
                message.members.push(exports.TableMember.fromPartial(e));
            }
        }
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=sql_engine.js.map